const navTreeData = {
    "code": 200,
    "msg": null,
    "data": [
        {
            "id": 0,
            "createBy": null,
            "createTime": null,
            "lastUpdateBy": "admin",
            "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
            "parentId": 0,
            "name": "工程信息",
            "url": "http://element.eleme.cn",
            "perms": null,
            "type": 1,
            "icon": "el-icon-document",
            "orderNum": 1,
            "delFlag": 0,
            "parentName": null,
            "level": 0,
            "children": []
        },
        {
            "id": 4,
            "createBy": null,
            "createTime": null,
            "lastUpdateBy": "admin",
            "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
            "parentId": 0,
            "name": "模型浏览",
            "url": "http://cn.vuejs.org/v2/guide/list.html",
            "perms": null,
            "type": 1,
            "icon": "el-icon-document",
            "orderNum": 1,
            "delFlag": 0,
            "parentName": null,
            "level": 0,
            "children": []
        },
        {
            "id": 1,
            "createBy": null,
            "createTime": null,
            "lastUpdateBy": "admin",
            "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
            "parentId": 0,
            "name": "工程进度管理",
            "url": null,
            "perms": null,
            "type": 1,
            "icon": "el-icon-document",
            "orderNum": 1,
            "delFlag": 0,
            "parentName": null,
            "level": 0,
            "children": [
                {
                    "id": 11,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": "admin",
                    "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
                    "parentId": 0,
                    "name": "进度管理",
                    "url": "http://www.tgcost.com",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-document",
                    "orderNum": 1,
                    "delFlag": 0,
                    "parentName": null,
                    "level": 0,
                    "children": []
                }, {
                    "id": 12,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": "admin",
                    "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
                    "parentId": 0,
                    "name": "进度监控",
                    "url": "http://cn.vuejs.org/v2/guide/index.html",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-document",
                    "orderNum": 1,
                    "delFlag": 0,
                    "parentName": null,
                    "level": 0,
                    "children": []
                }, {
                    "id": 13,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": "admin",
                    "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
                    "parentId": 0,
                    "name": "模拟建造",
                    "url": "http://cn.vuejs.org/v2/guide/computed.html",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-document",
                    "orderNum": 1,
                    "delFlag": 0,
                    "parentName": null,
                    "level": 0,
                    "children": []
                }

            ]
        },
        {
            "id": 2,
            "createBy": null,
            "createTime": null,
            "lastUpdateBy": "admin",
            "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
            "parentId": 0,
            "name": "快速估价",
            "url": "http://www.tgcost.com/gateway/bdm/res/html/bdm/index.html",
            "perms": null,
            "type": 1,
            "icon": "el-icon-document",
            "orderNum": 1,
            "delFlag": 0,
            "parentName": null,
            "level": 0,
            "children": []
        },
        {
            "id": 46,
            "createBy": null,
            "createTime": null,
            "lastUpdateBy": "admin",
            "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
            "parentId": 0,
            "name": "接口文档",
            "url": "http://127.0.0.1:8001/swagger-ui.html",
            "perms": null,
            "type": 1,
            "icon": "el-icon-document",
            "orderNum": 1,
            "delFlag": 0,
            "parentName": null,
            "level": 0,
            "children": []
        },
        {
            "id": 3,
            "createBy": null,
            "createTime": null,
            "lastUpdateBy": null,
            "lastUpdateTime": null,
            "parentId": 0,
            "name": "系统管理",
            "url": null,
            "perms": null,
            "type": 0,
            "icon": "el-icon-setting",
            "orderNum": 0,
            "delFlag": 0,
            "parentName": null,
            "level": 0,
            "children": [
                {
                    "id": 31,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "用户管理",
                    "url": "/sys/user",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-setting",
                    "orderNum": 1,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": []
                },
                {
                    "id": 32,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "企业管理",
                    "url": "/sys/dept",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-setting",
                    "orderNum": 2,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": []
                },
                {
                    "id": 33,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "角色管理",
                    "url": "/sys/role",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-setting",
                    "orderNum": 4,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": []
                },
                {
                    "id": 34,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "菜单管理",
                    "url": "/sys/menu",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-menu",
                    "orderNum": 5,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": []
                },
                {
                    "id": 35,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "系统配置",
                    "url": "/sys/config",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-menu",
                    "orderNum": 7,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": []
                }
            ]
        }

    ]
}
export default navTreeData;


// WEBPACK FOOTER //
// ./src/mock/modules/menu/navtreedata.js